import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import SalesTopSection from '../../../components/Sales-Information/SalesTopSection';
import SalesSubHeading from '../../../components/Sales-Information/SalesSubHeading';
import icon1 from '../../../assets/img/sales-info/icon1.png';
import icon2 from '../../../assets/img/sales-info/icon2.png';
import icon3 from '../../../assets/img/sales-info/icon3.png';
import { IoLocationOutline } from "react-icons/io5";
import { LuFilePen } from "react-icons/lu";
import { AiOutlineFileSearch } from "react-icons/ai";
import nextIcon from '../../../assets/img/sales-info/ico_next2.png';

const SaleInfo = () => {
  const navigate = useNavigate();

  const salesSteps = [
    {
      id: 1,
      title: "분양 상담",
      description: "홈페이지를 통한 상담 및 전화상담 1599-9442, 방문상담을 통해 계약관련 정보를 받으실 수 있습니다.",
      icon: <img src={icon1} alt="분양 상담" className="icon" />
    },
    {
      id: 2,
      title: "현장 방문",
      description: "홈페이지나 전화로 상담하신 후 현장을 직접 방문",
      icon: <img src={icon2} alt="현장 방문" className="icon" />
    },
    {
      id: 3,
      title: "위치 선택",
      description: "직접 현장을 방문하신 후에는 원하는 장소를 지정하시어 선택하실 수 있습니다.",
      icon: <IoLocationOutline />
    },
    {
      id: 4,
      title: "사용 계약",
      description: "원하는 장소를 선택하신 후에는 지정된 기간 안에 대금을 완납하시고 계약 서류를 작성하여 체결합니다.",
      icon: <LuFilePen />
    },
    {
      id: 5,
      title: "사용",
      description: "사용 계약체결 후에는 원하는 날짜에 사용 가능합니다. 사용 전 최소 하루 전에 전화 또는 사무실로 방문하시어 접수하시면 됩니다.",
      icon: <img src={icon3} alt="사용 계약" className="icon" />
    }
  ];

  const requiredDocuments = [
    {
      id: 1,
      title: "화장증명서",
      description: "화장증명서는 화장장에서 화장시 관리사무실(운영사무실)에 요청하시면 발급 받으실수 있습니다.",
    }
  ];

  return (
    <>
      <div className="announcement-list-page sale-info-page">
        <SalesTopSection />

        {/* Main Content */}
        <main className="main-content">
          <SalesSubHeading heading="분양안내" heading3="분양절차" />

          {/* Sales Procedure Section */}
          <section className="sale-procedure-section">
            <div className="sale-procedure-container">
              <h2 className="section-title">분양절차</h2>

              {/* Process Steps */}
              <div className="process-steps">
                {salesSteps.map((step, index) => (
                  <React.Fragment key={step.id}>
                    <div className="step-item">
                      <div className="step-icon">
                        <div className="icon-circle">
                          {step.icon}
                        </div>
                      </div>
                      <div className="step-content">
                        <span className="step-number">{step.id}</span>
                        <h3 className="step-title">{step.title}</h3>
                        <div className="step-description-box">
                          <p className="step-description">{step.description}</p>
                        </div>
                      </div>
                    </div>
                    {index < salesSteps.length - 1 && (
                      <div className="step-arrow">
                        <div className="step-arrow-icon">
                          <img src={nextIcon} alt="next" />
                        </div>
                      </div>
                    )}
                  </React.Fragment>
                ))}
              </div>

              {/* Required Documents */}
              <div className="required-documents">
                <h3 className="documents-title">구비서류</h3>
                <div className="documents-list">
                  {requiredDocuments.map((doc) => (
                    <div key={doc.id} className="document-item">
                      <div className="document-icon">
                        <div className="icon-circle">
                          <AiOutlineFileSearch />
                        </div>
                      </div>
                      <div className="document-content">
                        <h4 className="document-title">{doc.title}</h4>
                        <p className="document-description">{doc.description}</p>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </section>
        </main>
      </div>
    </>
  );
};

export default SaleInfo;